/* THIS FILE IS GENERATED. DO NOT EDIT */

import theme from 'base/components/standalone/PostActionDialog/theme';

export const PostActionDialogTheme = theme;
